module.exports = __webpack_public_path__ + "static/media/SharedBlue.0eb3e48d.svg";